import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing, fontWeight, palette, themeMode, token, variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import { Text } from '../Text/Text.es.js';
var sizeStyles = variant({
  prop: "size",
  variants: {
    sm: {
      fontSize: "sm",
      lineHeight: "16px",
      minHeight: "24px",
      py: "xs",
      px: "sm"
    },
    md: {
      fontSize: "md",
      lineHeight: "18px",
      minHeight: "48px",
      py: "xs",
      px: "md"
    }
  }
});
var Item = styled(Box).withConfig({
  componentId: "sc-1r5j05s-0"
})(["display:flex;align-items:center;max-width:100%;padding:0 ", ";font-weight:", ";user-select:none;cursor:", ";text-decoration:none;word-break:break-word;color:", ";background-color:", ";", ";&:hover{color:", ";background-color:", ";}&:active{color:", ";background-color:", ";}&[disabled]{pointer-events:none;opacity:0.5;}"], spacing("md"), fontWeight("bold"), function (_ref) {
  var onClick = _ref.onClick,
      disabled = _ref.disabled;
  return onClick && !disabled && "pointer";
}, palette("text.base"), function (_ref2) {
  var isSelected = _ref2.isSelected;
  return isSelected && themeMode({
    light: palette("neutral.100"),
    dark: palette("neutral.700")
  });
}, sizeStyles, palette("text.base"), themeMode({
  light: palette("neutral.100"),
  dark: palette("neutral.700")
}), palette("text.base"), themeMode({
  light: palette("neutral.100"),
  dark: palette("neutral.600")
}));
var Addon = styled(Box).withConfig({
  componentId: "sc-1r5j05s-1"
})(["display:flex;align-items:center;flex:0 1 auto;"]);
var ItemIcon = styled(Box).withConfig({
  componentId: "sc-1r5j05s-2"
})(["display:flex;align-items:center;margin-right:", ";"], function (_ref3) {
  var size = _ref3.size;
  return size === "md" ? spacing("md") : spacing("sm");
});
var ItemSecondaryAction = styled(Box).withConfig({
  componentId: "sc-1r5j05s-3"
})(["display:flex;align-items:center;margin-left:auto;"]);
var List = styled(Box).withConfig({
  componentId: "sc-1r5j05s-4"
})(["display:flex;flex-direction:column;max-width:100%;overflow:hidden;&:focus{outline:none;}"]);
var Subheader = styled(Text).withConfig({
  componentId: "sc-1r5j05s-5"
})(["padding:", " ", ";"], spacing("xs"), spacing("md"));
var Divider = styled("hr").withConfig({
  componentId: "sc-1r5j05s-6"
})(["width:100%;border:0;border-bottom:", ";margin-top:", ";margin-bottom:", ";"], token("borders.subtle"), spacing("xxs"), spacing("xxs"));
export { Addon, Divider, Item, ItemIcon, ItemSecondaryAction, List, Subheader };